import FixedHeader from "../components/FixedHeader";
import Notification from "../components/Notification";
import logoparque from "../img/logoparque.png";
import Block3Columns from "../components/Block3Columns";


function ParqueCientifico() {
  let mystyle = {
    backgroundImage: `url(${logoparque})`,
  };


  return (
    <>
      <FixedHeader
        video="https://utpl.edu.ec/recursos/videos/utpl.mp4"
        src="https://utpl.edu.ec/recursos/img/cabecera.jpg"
        span0={
          <>
            UTPL <b>Parque</b>
          </>
        }
        span3="Científico y"
        span4="Tecnológico"
      ></FixedHeader>

      <div style={mystyle} className="intro-parquecientifico">
        <Notification
          content={
            <>
              <h2>
                Somos un espacio de <b>innovación</b> y <b>emprendimiento</b>{" "}
                para impulsar la
                <b> investigación</b>, el <b>desarrollo tecnológico</b> y la{" "}
                <b>transferencia de conocimiento.</b>
              </h2>
            </>
          }
        ></Notification>
      </div>

   


      <div className="layout8 padding">
        <h2 className="width700">
          Fomentamos la{" "}
          <b>
            colaboración entre las empresas, gobierno, academia y sociedad civil
          </b>{" "}
          para contribuir a la creación de un{" "}
          <b>ecosistema de innovación sólido y dinámico.</b>
        </h2>
        Los sectores tecnológicos priorizados son: • Innovación alimentaria •
        Tecnologías de la información y comunicación • Biotecnología y
        farmacéutica • Industria cultural y creativa • Tecnologías innovadoras
        para el aprendizaje
      </div>
    </>
  );
}

export default ParqueCientifico;
